import React from 'react';
import './BannerHomePage.scss';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';

function CarouselMobile(props) {
  const {
    item,
    i,
    activeIndex,
    setActiveIndex,
    setIsActiveIntervalAutoOpenBanner,
    setButtonTextByIndexId,
    buttonOnBanner,
    getButtonClassByName,
    iContent,
    context
  } = props;

  const {
    priTitleMobile,
    secTitleMobile,
    textBannerMobile,
    imageMobile,
    buttonText,
    linkBanner,
    isBannerClickable
  } = item;
   
  let initialX = null;
  let initialY = null;
  
  //swipe on screen
  const touchStartOnScreenMobile = (e) => {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
  };

  const touchMoveOnScreenMobile = (e) => {
    setIsActiveIntervalAutoOpenBanner(false);

    if (initialX === null) return;
    if (initialY === null) return;
    
    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;
   
    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    let isRight = diffX > 0;
    
    if (Math.abs(diffX) > Math.abs(diffY)) {
      if (isRight) {  // sliding horizontally
       // swiped right 
        if(activeIndex != 0 )
          setActiveIndex(activeIndex - 1);
        else
          return  
      } else {
        // swiped left
        if(activeIndex != iContent.items.expandedValue.length-1)
          setActiveIndex(activeIndex + 1);
        else
          return;
      }
    }
    initialX = null;
    initialY = null;
  };

  const clickBanner = ()=> {
    if (isBannerClickable && linkBanner != null) {
        prepareUrl(linkBanner, context);
    };
  };

  return (
    <li
      onTouchStart={(e) => touchStartOnScreenMobile(e)}
      onTouchMove={(e) => touchMoveOnScreenMobile(e)}
      className='wrapper-banner-item'
    >
      <div className='image-item' style={{ backgroundImage: `url(${imageMobile.src})` }} onClick={() => clickBanner(i)}>
        <div className={`text-banner-open ${item.isWhiteText ? 'white-text' : ''}`}>
            <div className='only-text-banner'>
                {priTitleMobile.length > 0 && <div className='pri-title' dangerouslySetInnerHTML={{ __html: priTitleMobile }} />}
                {secTitleMobile.length > 0 && <div className='sec-title' dangerouslySetInnerHTML={{ __html: secTitleMobile }} />}
                {textBannerMobile.length > 0 && <div className='text-banner' dangerouslySetInnerHTML={{ __html: textBannerMobile }} />}
            </div>
            {
                !isBannerClickable &&
                <button className={getButtonClassByName(i)} onClick={() => buttonOnBanner(item,i)}>
                    {setButtonTextByIndexId(i)}
                </button>
            }
          </div>  
        </div>
    </li>
  )
}

export default CarouselMobile;